import React from 'react';
import "./video-pop-up.css";
import MeetingFull from '../../services/event/event-full';
import { toast } from 'react-toastify';

interface VideoPopupProps {
  visible: boolean;
  onClose: () => void;
  attendeeLoginUrl: string;
  eventId: string;
  userEmail: string;  
}

const VideoPopup: React.FC<VideoPopupProps> = ({ visible, onClose, attendeeLoginUrl, eventId, userEmail }) => {

  const handleGetVideo = async () => {
    const payload = {
      email: userEmail, 
    };

    try {
      const response = await MeetingFull(payload, eventId);
      if (response.status === 200) {
        toast.error(
          response.data.message,
          {
            onClose: () => {
              window.location.href = attendeeLoginUrl;
            },
          }
        );
      } else {
        console.error('Error occurred:', response.data);
      }
    } catch (error) {
      console.error('Unexpected error:', error);
    }
  };

  if (!visible) {
    return null;
  }

  return (
    <div className={`locked-pop-up`}>
      <h1>Session is full</h1>
      <p>Thank you for your interest. This webinar has reached capacity, You will be able to access the video on demand after the event.</p>
      <div className='but-box-wrapper'>
        <button onClick={handleGetVideo} className='pop-up-option'>
          Ok
        </button>
      </div>
    </div>
  );
};

export default VideoPopup;
